/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
    name: "MilestoneModal",
    components: { customModal },

    props: {
        editingId: {
            type: String,
            default: null
        }
    },

    emits: ["closeModal", "saved"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",

            studyId: "",

            milestone: {
                milestoneName: "",
                active: true
            },

            isEditMode: false,
            loading: false,

            errors: {
                name: false
            },

            errorMessages: {
                name: ""
            }
        };
    },

    async mounted() {
        this.token = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;

        if (this.editingId) {
            this.isEditMode = true;
            await this.fetchMilestoneById();
        }
    },

    methods: {

        clearErrors() {
            this.errors.name = false;
            this.errorMessages.name = "";
        },

        validate() {
            this.clearErrors();
            let isValid = true;

            if (!this.milestone.milestoneName || !this.milestone.milestoneName.trim()) {
                this.errors.name = true;
                this.errorMessages.name = "Please enter milestone name";
                isValid = false;
            }

            return isValid;
        },

        clearError() {
            this.errors.name = false;
            this.errorMessages.name = "";
        },

        async fetchMilestoneById() {
            try {
                this.loading = true;

                const response = await axios.get(
                    `${this.baseurl}/management/patient/getsubjectmilestonebyid?id=${this.editingId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token
                        }
                    }
                );

                const data = response.data;

                this.milestone = {
                    milestoneName: data.milestoneName || "",
                    active: data.active !== null && data.active !== undefined ? data.active : true
                };

            } catch (err) {
                console.error(err);
                alert("Failed to load milestone data");
            } finally {
                this.loading = false;
            }
        },

        async submitMilestone() {
            if (!this.validate()) return;

            try {
                if (this.isEditMode) {

                    const payload = {
                        milestoneId: this.editingId,
                        studyId: this.studyId,
                        milestoneName: this.milestone.milestoneName,
                        active: this.milestone.active
                    };

                    await axios.put(
                        `${this.baseurl}/management/patient/updatesubjectmilestone`,
                        payload,
                        {
                            headers: {
                                Authorization: "Bearer " + this.token
                            }
                        }
                    );

                    alert("Milestone updated successfully");

                } else {

                    const payload = {
                        studyId: this.studyId,
                        milestoneName: this.milestone.milestoneName,
                        active: this.milestone.active
                    };

                    await axios.post(
                        `${this.baseurl}/management/patient/createsubjectmilestone`,
                        payload,
                        {
                            headers: {
                                Authorization: "Bearer " + this.token
                            }
                        }
                    );

                    alert("Milestone created successfully");
                }

                this.$emit("saved");
                this.closeModal();

            } catch (err) {
                console.error(err);
                alert(err.response?.data?.detail || "Save failed");
            }
        },

        closeModal() {
            this.$emit("closeModal");
        }
    }
};